import { render, staticRenderFns } from "./AcademicSetting.vue?vue&type=template&id=5508aa48&"
import script from "./AcademicSetting.vue?vue&type=script&lang=js&"
export * from "./AcademicSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports